export const getBIQuestions = state => state.biQuestions.records
export const getBIQuestionsPageNumber = state => state.biQuestions.recordsPageNumber
export const getBIQuestionsCount = state => state.biQuestions.recordsCount
export const getBIQuestionStagedRecord = state => state.biQuestions.stagedRecord
